const validDownloadsSlugs = [
    'android',
    'applewatch',
    'chrome',
    'edge',
    'firefox',
    'gmail',
    'ios',
    'iphone',
    'ipad',
    'linux',
    'mac',
    'macos',
    'outlook',
    'safari',
    'wearos',
    'windows',
] as const

const validPlatforms = [
    'default',
    'linux',
    'mac',
    'windows',
    'iPhone',
    'iPad',
    'macos',
    'android',
    'appleWatch',
    'wearOS',
    'browser',
    'email',
] as const

const platformMap: Record<string, (typeof validPlatforms)[number]> = {
    default: 'default',
    linux: 'linux',
    mac: 'mac',
    macos: 'mac',
    windows: 'windows',
    ios: 'iPhone',
    iphone: 'iPhone',
    ipad: 'iPad',
    android: 'android',
    applewatch: 'appleWatch',
    wearos: 'wearOS',
    chrome: 'browser',
    edge: 'browser',
    firefox: 'browser',
    safari: 'browser',
    gmail: 'email',
    outlook: 'email',
}

const validPlatformTypes = ['mobile', 'tablet', 'desktop'] as const
const fallbacktoDefault = ['browser', 'email']

type PlatformType = (typeof validPlatformTypes)[number]
type Platform = (typeof validPlatforms)[number]

function validatedPlatform(slug = ''): Platform | undefined {
    const name = slug.toLowerCase() as (typeof validDownloadsSlugs)[number]
    return validDownloadsSlugs.includes(name) ? platformMap[name] : undefined
}

function validatedPlatformType(type = ''): PlatformType | undefined {
    const name = type.toLowerCase() as PlatformType
    return validPlatformTypes.includes(name) ? name : undefined
}

export {
    fallbacktoDefault,
    platformMap,
    validatedPlatform,
    validatedPlatformType,
    validDownloadsSlugs,
    validPlatforms,
    validPlatformTypes,
}
export type { Platform, PlatformType }
